export const INVOICE_PATH = '/invoice'
export const THEME_PATH = '/theme'
export const USER_ME_PATH = '/user/me'
export const USER_CREDIT_CARDS_PATH = '/user/credit_cards'
export const USER_WALLET_RECORDS_PATH = '/user/wallet_records'
export const USER_WALLET_ADD_VALUE_PATH = '/user/wallet/add'
export const SCHOOL_PAYMENT_SERVICE_CHARGES_PATH = '/service_charges'
export const QF_PAY_PATH = '/payment/pay'
export const QF_PAY_STATUS = '/payment/status'

export default {}
